import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgInsurance = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      d="M12 16.5q2.55-2.3 3.275-3.238Q16 12.325 16 11.4q0-.9-.65-1.55a2.12 2.12 0 0 0-1.55-.65q-.525 0-1.012.212A2 2 0 0 0 12 10q-.3-.375-.775-.588A2.5 2.5 0 0 0 10.2 9.2q-.9 0-1.55.65T8 11.4q0 .475.125.875t.55.937q.424.538 1.212 1.313T12 16.5m0 6q-3.475-.875-5.737-3.988T4 11.6V5.5l8-3 8 3v6.1q0 3.8-2.262 6.912T12 22.5m0-2.1q2.6-.825 4.3-3.3t1.7-5.5V6.875l-6-2.25-6 2.25V11.6q0 3.025 1.7 5.5t4.3 3.3"
      fill={props.color}
    />
  </Svg>
);
const Memo = memo(SvgInsurance);
export default Memo;
